import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { CustomerService } from './customer.service';
import { mergeMap, retry, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, timer } from 'rxjs';
import {CustomerServiceImpl} from "./customer.service.impl";

@Injectable({ providedIn: 'root' })
export class CustomerTranslateLoader implements TranslateLoader {

  public isLoading = new BehaviorSubject<boolean>(false);

  constructor(private httpClient: HttpClient) {
  }

  getTranslation(lang: string): Observable<any> {
    this.isLoading.next(true);

    const translationPath = environment.serverUri + `/customer/${CustomerServiceImpl.GetCustomerKey()}/translations.json?lang=${lang}`;

    return of(translationPath).pipe(mergeMap(path => {
      this.isLoading.next(true);
      return this.httpClient.get(path).pipe(tap(() => {
        this.isLoading.next(false);
      }), retry({
          delay: (error) => {
            console.warn('could not load translations', error);
            return timer(5000);
          }
        }
      ));
    }));
  }
}
